import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { contains } from 'ramda';
import { Checkbox } from 'antd';

import { ACTIONS_ENABLED_STATUSES } from 'constants/approvalStatuses';

const isRequestCheckable = ({ id }) => !id;
const isApprovalCheckable = ({ status }) => !contains(status, ACTIONS_ENABLED_STATUSES);

const checkStage = ({ stageKey }, { stage }) => stage && stageKey !== stage;

export class CheckboxCell extends Component {
    static propTypes = {
        disabled: PropTypes.bool,
        selected: PropTypes.array,
        rowIndex: PropTypes.number.isRequired,
        setSelected: PropTypes.func.isRequired,
        item: PropTypes.object.isRequired,
        isCheckable: PropTypes.func,
        stage: PropTypes.number,
    };

    handleClick = () => {
        const { item } = this.props;
        this.props.setSelected(item.id, { item });
    }

    render() {
        const { item, selected, isCheckable } = this.props;

        return (
            <div className="table-cell-center">
                <Checkbox
                    onChange={this.handleClick}
                    disabled={isCheckable && isCheckable(item, this.props)}
                    checked={contains(item.id, selected)}
                />
            </div>
        );
    }
}

const selectedToProps = (tableName, isCheckable) => (
    ({ table: { [tableName]: { selected, stage } } }) => ({
        selected,
        isCheckable,
        stage,
    })
);

export const createCheckboxCell = (tableName, setSelected, isCheckable = isApprovalCheckable) => (
    connect(selectedToProps(tableName, isCheckable), { setSelected })(
        CheckboxCell
    )
);

export const createNocheckCheckboxCell = (tableName, setSelected, isCheckable = isRequestCheckable) => (
    connect(selectedToProps(tableName, isCheckable), { setSelected })(
        CheckboxCell
    )
);

export const createMassCheckboxCell = (tableName, setSelected, isCheckable = checkStage) => (
    connect(selectedToProps(tableName, isCheckable), { setSelected })(
        CheckboxCell
    )
);
